<template>
  <button
    class="relative inline-block text-gpx_terracotta-300 after:absolute after:bottom-0 after:left-0 after:block after:h-px after:w-full after:bg-gpx_terracotta-800"
  >
    <slot />
  </button>
</template>

<script setup></script>
